import React from "react";
import { Table, TableHead, TableRow, TableCell, TableHeader, TableBody, Button } from "@ui";
import { GetAccountProfile, CreatePayment } from "@lib";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { RouteNavigation } from "@/Routes";
import { useOpenRazorpay } from '@/components/common/PaymentGateway';

function AccountProfile() {
    const openRazorpay = useOpenRazorpay();
    const { isError, data, } = useQuery({
        queryKey: ['AccountProfile'],
        queryFn: () => GetAccountProfile(),
    })
    const originalDate = data ? new Date(data?.data?.expireDate) : "";
    const formattedDate = originalDate ? `${originalDate.getMonth() + 1}/${originalDate.getDate()}/${originalDate.getFullYear()}` : "";
    let SubscriptionDetails: any;
    if (data?.data?.remainingDays[0] === "-") {
        SubscriptionDetails = "Account Expired Please Renew Subscription";
    } else {
        SubscriptionDetails = `Only ${data ? data?.data?.remainingDays : 0} days left, If you wish to continue using our service renew your subscription.`
    }
    const handleClick = async (profile: any) => {
        const dataResponse = await CreatePayment({ orderId: profile.SUP_Uid, amount: profile.SUP_Price, currency: profile.SUP_Currency })
        if (dataResponse.status === 200) {
            openRazorpay({ amount: parseFloat(profile.SUP_Price), order_id: dataResponse?.data?.OrderId, subscriptionPlan: profile });
        }
    };
    const colors = ["red", "green", "blue", "yellow", "purple"];
    return (
        <div className="p-1 md:mt-0 sm:p-8">
            <div className="flex justify-between p-3">
                <h2 className="mb-1 text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl">
                    Account Profile
                </h2>
                <Link to={RouteNavigation.deleteAccount}>
                    <Button variant={"delete"}>
                        Delete Account
                    </Button>
                </Link>
            </div>
            <div className="bg-[#D2E1FF] px-6 py-4 items-center rounded-xl">
                <div className="flex flex-col md:flex-row justify-between items-center">
                    <div>
                        Account Valid Till : <b>{formattedDate || 0}</b><br />
                        <span className="text-sm text-red-500">
                            {SubscriptionDetails}
                        </span>
                    </div>
                    <div className="w-full sm:w-[180px] text-end items-center">
                        {/* <RazorpayButton /> */}
                    </div>
                </div>
            </div >
            {/* <div className="py-6">
                <div className="overflow-auto">
                    <Table>
                        <TableHeader>
                            <TableRow>
                                <TableHead className="text-center">Plan Name</TableHead>
                                <TableHead className="text-center">Plan Validity</TableHead>
                                <TableHead className="text-center">Amount</TableHead>
                                <TableHead className="text-center">Subscribe</TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {!isError && data?.data?.SubscriptionPackageList?.map((profile: any, index: number) => {
                                return (
                                    <TableRow key={index}>
                                        <TableCell className="text-center p-2">{profile.SUP_Name}</TableCell>
                                        <TableCell className="text-center p-2">For {profile.SUP_Days} Days</TableCell>
                                        <TableCell className="text-center p-2 default_font">{profile.SUP_Price} ₹ </TableCell>
                                        <TableCell className="text-center p-2">
                                            <button onClick={() => handleClick(profile)}>Pay</button>
                                        </TableCell>
                                    </TableRow>
                                )
                            })
                            }
                        </TableBody>
                    </Table>
                </div>
            </div> */}
            <section className="bg-white dark:bg-gray-900">
                <div className="py-8 px-4 mx-auto max-w-screen-xl">
                    <div className="mx-auto max-w-screen-md text-center mb-8 lg:mb-12">
                        <h2 className="mb-4 text-4xl tracking-tight font-extrabold text-gray-900 dark:text-white">Report App Subscription Plans</h2>
                        <p className="mb-5 font-light text-gray-500 sm:text-xl dark:text-gray-400">Choose the plan that&apos;s right for you</p>
                    </div>
                    <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 sm:gap-6 xl:gap-10">
                        {!isError && data?.data?.SubscriptionPackageList?.map((profile: any, index: number) => (
                            <div className={`flex flex-col hover:shadow-lg hover:scale-105 transform-all duration-300 p-6 mx-auto w-full text-center text-gray-900 bg-${colors[index % colors.length]}-100 border border-${colors[index % colors.length]}-600 rounded-[10px] shadow xl:p-8`}>
                                <h3 className="mb-4 text-2xl font-semibold">{profile.SUP_Name}</h3>
                                <p className="font-light text-gray-500 sm:text-lg dark:text-gray-400">Validity Upto {profile.SUP_Days} days</p>
                                <div className="flex justify-center items-baseline my-8">
                                    <span className="mr-2 text-5xl font-extrabold">₹ {profile.SUP_Price}</span>
                                    {<span className="text-gray-500 dark:text-gray-400"> only</span>}
                                </div>
                                <button className="text-white bg-blue-600 font-medium rounded-full text-sm px-5 py-2.5 text-center" onClick={() => handleClick(profile)}>Pay</button>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    )
}
export default AccountProfile;